export class GradoDifficolta {
    id?: number;
    name?: string;
    selected?: boolean;

    constructor() {
        
    }
}
